import WorkoutDeletionModal from './WorkoutDeletionModal';

export default WorkoutDeletionModal;
